import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";
import ModuleQuestion from "../../components/ModuleQuestion";

const Module_1_0 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}

      <main className="col-sm-8 module-content">
        <section>
          <h1 className="blue text-uppercase b mt-5 mb-4">3.0.12 Case 12</h1>
          <p className="me-4">Estimated time to complete: 3-5 minutes</p>
        </section>
        <ModuleQuestion
          correctAnswer="A"
          assessmentName="self_assessment_112"
          videoTranscript={
            <>
              <p>
                <strong>AUDIO</strong>
                <br />
                VO: (FEMALE)
                <br />
                This is self-assessment case number 112, or one, one, two. This
                is a positive case. Beginning at the bottom of the scan, focal
                uptake is seen in the posterior aspect. This uptake is within
                the bone and should not be confused with uptake in the occipital
                cortex. Moving upwards and entering into the occipital cortex,
                seen here, increased activity is seen extending to the cortical
                rim. In order to further localize this activity, you can utilize
                the fused images, seen here. Increased activity, seen here, is
                within the cortical gray matter, and, therefore, there is loss
                of gray-white contrast in the occipital regions, seen here. When
                using PET-CT images, one should be cautious, as it is very
                difficult to see gray-white contrast when one also has the image
                overlaid on top of the CT. Returning to the PET images and
                continuing to move superiorly, the temporal regions also show
                loss of gray-white contrast bilaterally. Distinct white matter
                tracts are not easily identifiable on the left or the right. At
                the temporoparietal junction, seen here, there is also increased
                activity in the cortical gray matter, with subsequent loss of
                gray-white contrast. As we enter into the medial parietal region
                and frontal region, seen here, there is also loss of gray-white
                contrast. Distinct white matter tracts are not visualized on the
                left or right. Posteriorly, in the medial parietal region, which
                also includes a small area called the precuneus, there is also
                increased activity in the gray matter. Therefore, as there is
                loss of gray-white contrast in the frontal, medial parietal,
                temporal, and occipital regions, this case is positive.
              </p>
            </>
          }
          previousLesson="/module-3/module-3-0-11"
          nextLesson="/module-3/module-3-0-13"
          iframeURL="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_1562237176&entry_id=1_tycitu2z&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true"
          questionType="assessment"
          videoId="1_tycitu2z"
        />
      </main>
    </div>
  );
};

export default Module_1_0;
